import dayjs from 'dayjs';

import { ReportDateRange } from '@shared/types/ReportTypes';

export const getReportNotificationId = (
  patientPrismaCloudId: string,
  dateRange: ReportDateRange,
  language: string,
): string => {
  const startDate = dayjs(dateRange.startDate);
  const endDate = dayjs(dateRange.endDate);

  const startDateString = startDate.isValid() ? startDate.format('YYYY-MM-DD') : '';
  const endDateString = endDate.isValid() ? endDate.format('YYYY-MM-DD') : '';

  return `${patientPrismaCloudId}_${startDateString}-${endDateString}_${language}`;
};
